var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0495 30.7714C23.0495 31.3625 22.8151 31.9293 22.3978 32.3473C21.9806 32.7652 21.4146 33 20.8245 33C20.2345 33 19.6685 32.7652 19.2513 32.3473C18.834 31.9293 18.5996 31.3625 18.5996 30.7714V19.2286C18.5996 18.6375 18.834 18.0707 19.2513 17.6527C19.6685 17.2348 20.2345 17 20.8245 17C21.4146 17 21.9806 17.2348 22.3978 17.6527C22.8151 18.0707 23.0495 18.6375 23.0495 19.2286V30.7714ZM31.3996 30.7714C31.3996 31.3625 31.1652 31.9293 30.7479 32.3473C30.3307 32.7652 29.7648 33 29.1747 33C28.5846 33 28.0187 32.7652 27.6014 32.3473C27.1842 31.9293 26.9497 31.3625 26.9497 30.7714V19.2286C26.9497 18.6375 27.1842 18.0707 27.6014 17.6527C28.0187 17.2348 28.5846 17 29.1747 17C29.7648 17 30.3307 17.2348 30.7479 17.6527C31.1652 18.0707 31.3996 18.6375 31.3996 19.2286V30.7714Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#111111",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.fe05935b77315ebbac4ad0496ff4db88.svg";
export { ForwardRef as ReactComponent };